import React from "react";

// The one thing that needs the coach (CD7): a white strip with a teal edge,
// one line and a teal link. `step`: { text, sub, action, onClick, disabled }.
const NextStep = ({ step }) =>
  step ? (
    <div className="opc-pv-next">
      <div className="d-flex flex-column">
        <span className="dark-grey fw-bold small">{step.text}</span>
        <span className="light-text small">{step.sub}</span>
      </div>
      <button
        type="button"
        className="opc-pv-link"
        onClick={step.onClick}
        disabled={step.disabled}
      >
        {step.action}
        {step.disabled ? null : (
          <img
            src="/assets/images/base_primary_right.svg"
            alt=""
            width={12}
            height={12}
          />
        )}
      </button>
    </div>
  ) : null;

export default NextStep;
